const appConfig = {
  environment: "PRODUCTION",
  domain: {
    PRODUCTION: {
      agribazaar: "https://api.agribazaar.com",
      blog: "https://blog.agribazaar.com",
      noderefresh: "https://api2.agribazaar.com",
    },
    UAT: {
      agribazaar: "http://apiuat.agribazaar.com",
      blog: "http://bloguat.agribazaar.com",
      noderefresh: "http://api2uat.agribazaar.com",
    },
  },
  route: {
    PRODUCTION: "https://trade.agribazaar.com",
    UAT: "http://tradeuat.agribazaar.com"
  },
  farmerScoreCardRoute: {
    PRODUCTION: "https://finance.agribazaar.com/",
    UAT: "https://financedev.agribazaar.com/"
  },
  marketPlace: {
    PRODUCTION: "https://marketplace.agribazaar.com/",
    UAT: "https://uatmarketplace.agribazaar.com/"
  },
  blog: {
    PRODUCTION: "https://blog.agribazaar.com",
    UAT: "https://bloguat.agribazaar.com"
  },
  pvtAgribazaar:{
    PRODUCTION: "https://pvt.agribazaar.com/bo/login",
    UAT: "https://pvt-staging.agribazaar.com/bo/login"
  },
  nafed: {
    PRODUCTION: "https://nafed.agribazaar.com",
    UAT: "https://nafeduat.agribazaar.com"
  },
  chatbot: {
    PRODUCTION: {
      url: "https://pvt.agribazaar.com/api/v2/leads",
      name: "AGRIBAZAAR_WEB_APP",
      token: "TUcvrgUnANf6wZxfcPNBt75nd9NuZREq"
    },
    UAT: {
      url: "https://pvt-staging.agribazaar.com/api/v2/leads",
      name: "AGRIBAZAAR_WEB_APP",
      token: "EUcvrgUnANf6wZxfcPNBt75nd9NuZREm"
    },
    DEV: {
      url: "https://pvt-staging.agribazaar.com/api/v2/leads",
      name: "AGRIBAZAAR_WEB_APP",
      token: "EUcvrgUnANf6wZxfcPNBt75nd9NuZREm"
    },
  }
};

export default appConfig;
